import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_WORKSTREAMS_PATH,
  GetWorkstreamsErrorDto,
  GetWorkstreamsRequestPathVariables,
  GetWorkstreamsSuccessDto,
} from '@/api/rest/resources/types/workstreams';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetWorkstreamsSuccessDto;
type ErrorDto = GetWorkstreamsErrorDto;

export const useWorkstreams = (organizationIdArg?: string) => {
  const orgId = useOrganizationId();

  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(organizationId, 'organizationId');

  const pathVariables: GetWorkstreamsRequestPathVariables = { organization_id: organizationId };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_WORKSTREAMS_PATH, pathVariables);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', organizationId, 'workstreams'],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
